import { frontendURL } from '../../../helper/URLHelper';
import Queues from './Queues.vue';
import Overview from './Overview.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/wallboard'),
      name: 'wallboard',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Overview,
    },
    {
      path: frontendURL('accounts/:accountId/wallboard/queues'),
      name: 'wallboard_queues',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Queues,
    },
  ],
};
